import { useEditor } from "@craftjs/core";
function useSegmentBuilder() {
  const { actions, selected, isEnabled } = useEditor((state, query) => {
    const currentNodeId = query.getEvent("selected").last();
    let selected;

    if (currentNodeId && currentNodeId !== "ROOT") {
      selected = {
        id: currentNodeId,
        name: state.nodes[currentNodeId].data.name,
        settings:
          state.nodes[currentNodeId].related &&
          state.nodes[currentNodeId].related.settings,
        isDeletable: query.node(currentNodeId).isDeletable(),
      };
    }

    return {
      selected,
      isEnabled: state.options.enabled,
    };
  });

  const isToolSelected = () => {
    return { actions, selected, isEnabled };
  };

  return {
    isToolSelected,
  };
}
export default useSegmentBuilder;
